const WORD_DOCUMENT_STYLE_MAP = [
  "u => u", // Preserve underlines
];

export const useWordDocumentHtmlConversionOptions = () => ({
  styleMap: WORD_DOCUMENT_STYLE_MAP,
  // TODO(student-upload-images): implement real image support here instead of dropping Word document images.
  convertImage: async () => [],
});

export const useStripWordDocumentImagesFromHtml = (html: string) => {
  return html.replace(/<img\b[^>]*>/gi, "");
};
